import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    Optional,
    SkipSelf,
    ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@klickdata/core/auth';
import { MobileService } from '@klickdata/core/mobile';
import { QuestionTypes } from '@klickdata/core/question';
import { ResourceService } from '@klickdata/core/resource';
import { ResourceBuilderComponent } from '../../resource-builder.component';
import { ResourceBuilderService } from '../../resource-builder.service';
import { NestedResourceBuilderBinding } from '../nested-resource-builder-binding';
import { ResourceItemDirective } from '../resource-item.directive';

@Component({
    selector: 'app-resource-builder-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestComponent extends ResourceItemDirective implements OnDestroy {
    public questionTypes = [
        QuestionTypes.CHECKBOX,
        QuestionTypes.RADIO,
        QuestionTypes.WOK,
        QuestionTypes.INPUT,
        QuestionTypes.AI,
    ];
    private readonly nestedBuilderBinding = new NestedResourceBuilderBinding();

    @ViewChild(ResourceBuilderComponent)
    set nestedResourceBuilder(builder: ResourceBuilderComponent) {
        this.nestedBuilderBinding.bind(builder, this.parentBuilderService, this.childGroup);
    }

    constructor(
        protected resourceService: ResourceService,
        protected fb: FormBuilder,
        protected changeRef: ChangeDetectorRef,
        protected dialog: MatDialog,
        protected authService: AuthService,
        protected mobileService: MobileService,
        protected bottomSheet: MatBottomSheet,
        @Optional() @SkipSelf() protected parentBuilderService: ResourceBuilderService
    ) {
        super(resourceService, changeRef, dialog, authService, mobileService, bottomSheet);
    }

    public ngOnDestroy(): void {
        this.nestedBuilderBinding.destroy();
        super.ngOnDestroy();
    }
}
